import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Maria } from './components/Maria';
import { Advantages } from './components/Advantages';
import { Services } from './components/Services';
import { Clients } from './components/Clients';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background text-primary" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Maria data-id="element-5" />
        <Advantages data-id="element-6" />
        <Services data-id="element-7" />
        <Clients data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Contact data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}